import Collapse from '@material-ui/core/Collapse';
import type { TrackedTranslation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback, useState } from 'react';

import Info from '@swf/core/assets/icons/info.svg';
import GreenArrow from '@swf/first/assets/icons/green-arrow.svg';

import Button from '../Button/Button';

import {
  active,
  arrow,
  collapseContainer,
  container,
  expandButton,
  icon
} from './CollapsiblePanel.scss';

const collapseClasses: Record<string, string> = {
  root: collapseContainer
};

interface Props {
  className?: string;
  label: TrackedTranslation;
  icon?: 'info';
}

const CollapsiblePanel: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  icon: iconName,
  label,
  children
}) => {
  const [expand, setExpand] = useState(false);

  const buttonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setExpand(!expand);
    },
    [expand, setExpand]
  );

  return (
    <div className={classNames(container, className, { [active]: expand })}>
      <Button
        firstVariant="dropdown"
        translation={label}
        endIcon={<GreenArrow className={classNames(arrow, { [active]: expand })} />}
        firstButtonIcon={iconName && <Info className={icon} width={16} height={16} />}
        className={expandButton}
        onClick={buttonClick}
      />
      <Collapse classes={collapseClasses} in={expand}>
        {children}
      </Collapse>
    </div>
  );
};

export default CollapsiblePanel;
